import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSavingsAccountDeposit = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 55,
	height: 55,
	viewBox: "0 0 55 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6401_3389)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2.16504 5.0293H44.8838C45.1437 5.02939 45.3544 5.24012 45.3545 5.5V32.6846C45.3545 32.9445 45.1437 33.1552 44.8838 33.1553H2.16504C1.9051 33.1552 1.69434 32.9445 1.69434 32.6846V5.5C1.69443 5.24011 1.90515 5.02939 2.16504 5.0293Z",
				fill: "#269378",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.4121 8.31836C36.6542 11.4129 39.1213 13.88 42.2158 14.1221V24.8154C39.1213 25.0575 36.6543 27.5247 36.4121 30.6191H10.1846C9.94243 27.5247 7.47532 25.0575 4.38086 24.8154V14.1221C7.47537 13.88 9.9425 11.4129 10.1846 8.31836H36.4121Z",
				fill: "#10D9A8",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2998 13.1738C26.777 13.1738 29.5956 15.9926 29.5957 19.4697C29.5957 22.947 26.7771 25.7656 23.2998 25.7656C19.8227 25.7655 17.0039 22.9469 17.0039 19.4697C17.004 15.9926 19.8227 13.1739 23.2998 13.1738Z",
				fill: "#269378",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.89258 10.6895H53.2812C53.5747 10.6895 53.8123 10.9273 53.8125 11.2207V40.1045C53.8125 40.398 53.5748 40.6357 53.2812 40.6357H7.89258C7.59919 40.6356 7.36133 40.3979 7.36133 40.1045V11.2207C7.36149 10.9274 7.59929 10.6896 7.89258 10.6895Z",
				fill: "#269378",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.5518 13.7812C44.7953 17.0768 47.4252 19.7054 50.7207 19.9492V31.3691C47.4253 31.6129 44.7955 34.2427 44.5518 37.5381H16.6279C16.3841 34.2426 13.7546 31.6127 10.459 31.3691V19.9492C13.7547 19.7056 16.3843 17.0769 16.6279 13.7812H44.5518Z",
				fill: "#10D9A8",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.5869 18.9414C34.2987 18.9414 37.3075 21.9504 37.3076 25.6621C37.3076 29.3739 34.2987 32.3828 30.5869 32.3828C26.8752 32.3827 23.8662 29.3739 23.8662 25.6621C23.8663 21.9504 26.8752 18.9415 30.5869 18.9414Z",
				fill: "#269378",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .22,
				d: "M40.9072 14.8125C43.1722 14.8125 45.4263 15.1614 47.0947 15.8242C48.8053 16.5038 49.6913 17.4172 49.6914 18.4385V21.5332C49.6914 21.814 49.621 22.0806 49.4902 22.3408L49.377 22.5645L49.4902 22.7891C49.621 23.0493 49.6914 23.3159 49.6914 23.5967V26.6914C49.6914 26.972 49.6209 27.238 49.4902 27.498L49.377 27.7227L49.4902 27.9473C49.6209 28.2073 49.6914 28.4733 49.6914 28.7539V31.8486C49.6914 32.1294 49.621 32.396 49.4902 32.6562L49.377 32.8809L49.4902 33.1045C49.621 33.3647 49.6914 33.6313 49.6914 33.9121V37.0068C49.6914 37.2874 49.6209 37.5534 49.4902 37.8135L49.377 38.0381L49.4902 38.2627C49.6209 38.5227 49.6913 38.7887 49.6914 39.0693V40.6328H32.123V39.0693C32.1231 38.7887 32.1935 38.5228 32.3242 38.2627L32.4365 38.0381L32.3242 37.8135C32.1935 37.5534 32.1231 37.2875 32.123 37.0068V33.9121C32.123 33.6313 32.1934 33.3647 32.3242 33.1045L32.4365 32.8809L32.3242 32.6562C32.1934 32.396 32.123 32.1294 32.123 31.8486V28.7539C32.1231 28.4732 32.1935 28.2074 32.3242 27.9473L32.4365 27.7227L32.3242 27.498C32.1935 27.2379 32.1231 26.9721 32.123 26.6914V23.5967C32.123 23.3159 32.1934 23.0493 32.3242 22.7891L32.4365 22.5645L32.3242 22.3408C32.1934 22.0806 32.123 21.814 32.123 21.5332V18.4385C32.1232 17.4171 33.0092 16.5038 34.7197 15.8242C36.3882 15.1615 38.6423 14.8125 40.9072 14.8125Z",
				fill: "black",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.7158 45.7598H51.2207C51.5141 45.7598 51.7528 45.9976 51.7529 46.291V49.3857C51.7529 50.4071 50.8668 51.3204 49.1562 52C47.4878 52.6628 45.2337 53.0117 42.9688 53.0117C40.7038 53.0117 38.4497 52.6628 36.7812 52C35.0706 51.3204 34.1846 50.4072 34.1846 49.3857V46.291C34.1847 45.9977 34.4225 45.7599 34.7158 45.7598Z",
				fill: "#EF963C",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9688 42.668C45.2337 42.668 47.4878 43.0169 49.1562 43.6797C50.8668 44.3592 51.7528 45.2726 51.7529 46.2939C51.7529 47.3153 50.8668 48.2286 49.1562 48.9082C47.4878 49.571 45.2337 49.9199 42.9688 49.9199C40.7038 49.9199 38.4497 49.571 36.7812 48.9082C35.0706 48.2286 34.1846 47.3154 34.1846 46.2939C34.1847 45.2726 35.0707 44.3592 36.7812 43.6797C38.4497 43.0169 40.7039 42.668 42.9688 42.668Z",
				fill: "#FFD83A",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.7158 40.6055H51.2207C51.5141 40.6055 51.7528 40.8433 51.7529 41.1367V44.2314C51.7529 45.2528 50.8668 46.1661 49.1562 46.8457C47.4878 47.5085 45.2337 47.8574 42.9688 47.8574C40.7038 47.8574 38.4497 47.5085 36.7812 46.8457C35.0706 46.1661 34.1846 45.2529 34.1846 44.2314V41.1367C34.1847 40.8434 34.4225 40.6056 34.7158 40.6055Z",
				fill: "#EF963C",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9688 37.5117C45.2337 37.5117 47.4878 37.8606 49.1562 38.5234C50.8668 39.203 51.7528 40.1164 51.7529 41.1377C51.7529 42.1591 50.8668 43.0724 49.1562 43.752C47.4878 44.4148 45.2337 44.7637 42.9688 44.7637C40.7038 44.7637 38.4497 44.4148 36.7812 43.752C35.0706 43.0723 34.1846 42.1591 34.1846 41.1377C34.1847 40.1164 35.0707 39.203 36.7812 38.5234C38.4497 37.8607 40.7039 37.5117 42.9688 37.5117Z",
				fill: "#FFD83A",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.7158 35.4453H51.2207C51.5141 35.4453 51.7528 35.6832 51.7529 35.9766V39.0713C51.7529 40.0927 50.8668 41.0059 49.1562 41.6855C47.4878 42.3484 45.2337 42.6972 42.9688 42.6973C40.7038 42.6973 38.4497 42.3484 36.7812 41.6855C35.0706 41.0059 34.1846 40.0927 34.1846 39.0713V35.9766C34.1847 35.6833 34.4225 35.4455 34.7158 35.4453Z",
				fill: "#EF963C",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9688 32.3535C45.2337 32.3535 47.4878 32.7024 49.1562 33.3652C50.8668 34.0448 51.7528 34.9582 51.7529 35.9795C51.7529 37.0009 50.8668 37.9142 49.1562 38.5938C47.4878 39.2566 45.2337 39.6054 42.9688 39.6055C40.7038 39.6055 38.4497 39.2566 36.7812 38.5938C35.0706 37.9141 34.1846 37.0009 34.1846 35.9795C34.1847 34.9582 35.0707 34.0448 36.7812 33.3652C38.4497 32.7025 40.7039 32.3535 42.9688 32.3535Z",
				fill: "#FFD83A",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.7158 30.2871H51.2207C51.5141 30.2871 51.7528 30.525 51.7529 30.8184V33.9131C51.7529 34.9345 50.8668 35.8477 49.1562 36.5273C47.4878 37.1902 45.2337 37.539 42.9688 37.5391C40.7038 37.5391 38.4497 37.1902 36.7812 36.5273C35.0706 35.8477 34.1846 34.9345 34.1846 33.9131V30.8184C34.1847 30.5251 34.4225 30.2873 34.7158 30.2871Z",
				fill: "#EF963C",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9688 27.1934C45.2337 27.1934 47.4878 27.5423 49.1562 28.2051C50.8668 28.8846 51.7528 29.798 51.7529 30.8193C51.7529 31.8407 50.8668 32.754 49.1562 33.4336C47.4878 34.0964 45.2337 34.4453 42.9688 34.4453C40.7038 34.4453 38.4497 34.0964 36.7812 33.4336C35.0706 32.754 34.1846 31.8408 34.1846 30.8193C34.1847 29.798 35.0707 28.8846 36.7812 28.2051C38.4497 27.5423 40.7039 27.1934 42.9688 27.1934Z",
				fill: "#FFD83A",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.7158 25.1328H51.2207C51.5141 25.1328 51.7528 25.3707 51.7529 25.6641V28.7588C51.7529 29.7802 50.8668 30.6934 49.1562 31.373C47.4878 32.0359 45.2337 32.3847 42.9688 32.3848C40.7038 32.3848 38.4497 32.0359 36.7812 31.373C35.0706 30.6934 34.1846 29.7802 34.1846 28.7588V25.6641C34.1847 25.3708 34.4225 25.133 34.7158 25.1328Z",
				fill: "#EF963C",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9688 22.0391C45.2337 22.0391 47.4878 22.388 49.1562 23.0508C50.8668 23.7303 51.7528 24.6437 51.7529 25.665C51.7529 26.6864 50.8668 27.5997 49.1562 28.2793C47.4878 28.9421 45.2337 29.291 42.9688 29.291C40.7038 29.291 38.4497 28.9421 36.7812 28.2793C35.0706 27.5997 34.1846 26.6865 34.1846 25.665C34.1847 24.6437 35.0707 23.7303 36.7812 23.0508C38.4497 22.388 40.7039 22.0391 42.9688 22.0391Z",
				fill: "#FFD83A",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.7158 19.9707H51.2207C51.5141 19.9707 51.7528 20.2086 51.7529 20.502V23.5967C51.7529 24.6181 50.8668 25.5313 49.1562 26.2109C47.4878 26.8738 45.2337 27.2226 42.9688 27.2227C40.7038 27.2227 38.4497 26.8737 36.7812 26.2109C35.0706 25.5313 34.1846 24.6181 34.1846 23.5967V20.502C34.1847 20.2087 34.4225 19.9709 34.7158 19.9707Z",
				fill: "#EF963C",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9688 16.8789C45.2337 16.8789 47.4878 17.2278 49.1562 17.8906C50.8668 18.5702 51.7528 19.4836 51.7529 20.5049C51.7529 21.5263 50.8668 22.4395 49.1562 23.1191C47.4878 23.782 45.2337 24.1308 42.9688 24.1309C40.7038 24.1309 38.4497 23.7819 36.7812 23.1191C35.0706 22.4395 34.1846 21.5263 34.1846 20.5049C34.1847 19.4836 35.0707 18.5702 36.7812 17.8906C38.4497 17.2279 40.7039 16.8789 42.9688 16.8789Z",
				fill: "#FFD83A",
				stroke: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6401_3389",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 55,
			height: 55,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgSavingsAccountDeposit);
export { ForwardRef as ReactComponent };
